import { v4 as uuid } from 'uuid';

/**
 * Utilitário para geração e validação de UUIDs.
 */
const uuidUtil = {

    /**
     * Gera um UUID v4.
     *
     * @returns {string} Um UUID v4 gerado.
     */
    generate() {
        return uuid();
    },

    /**
     * Valida se o UUID fornecido está no formato correto (UUID v4).
     *
     * @param {string} uuid - O UUID a ser validado.
     * @returns {boolean} Retorna `true` se o UUID for válido, caso contrário, `false`.
     */
    validate(uuid) {
        const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
        return uuidRegex.test(uuid);
    }
}

export default uuidUtil;
